import { faAsterisk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { t } from "i18next";
import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const SubstituteInstructor = (props) => {
    const { c, i } = props;
    return (
        <>
            <OverlayTrigger
                trigger={["hover", "focus", "click"]}
                placement="top"
                delay={{ show: 150, hide: 100 }}
                overlay={<Tooltip id={`instructorGuestBtnTooltip${i}`}>{t("users.instructorGuest")}</Tooltip>}
            >
                <Button variant="link" size="sm" className="text-secondary p-0">
                    <FontAwesomeIcon icon={faAsterisk} className="me-lg-2 me-1" />
                </Button>
            </OverlayTrigger>
            {c.instructor_label}
        </>
    );
};

export default SubstituteInstructor;
